export const getDoors = (state) => state.doors